import { DOCUMENTS_NAMESPACE } from 'documents-lib/js/tracking/events';
import { POSITIVE_FEEDBACK_OPTIONS, NEGATIVE_FEEDBACK_OPTIONS } from '../../constants/DocumentDescriptionFeedbackOptions';
import FeedbackCopyButtons from 'sales-enablement-lib/components/feedback/FeedbackCopyButtons';
import { jsx as _jsx } from "react/jsx-runtime";
const DescriptionFeedback = ({
  correlationId,
  description,
  feedbackDisabled,
  isSaving,
  isLoading,
  submitDescriptionFeedback
}) => {
  const submitFeedbackVote = vote => {
    submitDescriptionFeedback({
      correlationId,
      vote
    });
  };
  const submitFeedbackForm = ({
    vote,
    options,
    feedbackMessage
  }) => {
    submitDescriptionFeedback({
      correlationId,
      vote,
      selectedFormOptions: options,
      feedbackMessage
    }, true);
  };
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(FeedbackCopyButtons, {
      copyDisabled: isSaving || isLoading || !description,
      copyMessage: description,
      copyTooltipI18nKey: "summary.description.feedback.copy.tooltip",
      feedbackDisabled: feedbackDisabled,
      positiveFeedbackTooltipI18Key: "summary.description.feedback.positiveFeedback.tooltip",
      negativeFeedbackTooltipI18Key: "summary.description.feedback.negativeFeedback.tooltip",
      positiveFeedbackOptions: POSITIVE_FEEDBACK_OPTIONS,
      negativeFeedbackOptions: NEGATIVE_FEEDBACK_OPTIONS,
      onPositiveClick: ({
        vote
      }) => {
        submitFeedbackVote(vote);
      },
      onNegativeClick: ({
        vote
      }) => {
        submitFeedbackVote(vote);
      },
      onNegativeFormSubmit: ({
        vote,
        options,
        feedbackMessage
      }) => {
        submitFeedbackForm({
          vote,
          options,
          feedbackMessage
        });
      },
      onPositiveFormSubmit: ({
        vote,
        options,
        feedbackMessage
      }) => {
        submitFeedbackForm({
          vote,
          options,
          feedbackMessage
        });
      },
      usageTrackerEventNamespace: DOCUMENTS_NAMESPACE
    }, correlationId)
  });
};
export default DescriptionFeedback;